import React, { useCallback, useContext, useEffect, useRef } from 'react'
import { Modal, Button, Form, Col, Row, Container } from '@themesberg/react-bootstrap'
import { Context } from '../..'

const _Popup = () => {

  const { state, dispatch } = useContext(Context);

  const _id = useRef(state.addPopup.id)
  const _title = useRef(state.addPopup.title)
  const _subTitle = useRef(state.addPopup.subTitle)

  useEffect(() => {
    _id.current = state.addPopup.id
    _title.current = state.addPopup.title
    _subTitle.current = state.addPopup.subTitle
  }, [state.addPopup.id, state.addPopup.title, state.addPopup.subTitle])

  const handleClose = useCallback(() => {
    dispatch({
      type: 'CLOSE_ADD_POPUP',
      payload: {
        confirmed: false,
        id: undefined,
        title: undefined,
        subTitle: undefined,
      },
    })
  }, [])

  const handleConfirm = useCallback(() => {
    dispatch({
      type: 'CLOSE_ADD_POPUP',
      payload: {
        confirmed: true,
        id: _id.current,
        title: _title.current,
        subTitle: _subTitle.current,
      },
    })
  }, [])

  const onChangeTitle = useCallback((payload) => {
    _title.current = payload.target.value;
  }, [])

  const onChangeSubTitle = useCallback((payload) => {
    _subTitle.current = payload.target.value;
  }, [])

  return (
    <Modal as={Modal.Dialog} centered show={state.addPopup.show} size='xl'>
      <Modal.Header>
        <Modal.Title className="h6">Thêm nhóm quảng cáo</Modal.Title>
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Col>
            <Row className='p-1'>
              <Col sm={12} md={12}>
                <Row>
                  <Col md={3} className='text-left align-self-center'>
                    <Form.Label>Tiêu đề</Form.Label>
                  </Col>
                  <Col md={9}>
                    <Form.Control onChange={onChangeTitle} required type="text" placeholder="Nhập tiêu đề" defaultValue={state.addPopup.title} />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className='p-1'>
              <Col sm={12} md={12}>
                <Row>
                  <Col md={3} className='text-left align-self-center'>
                    <Form.Label>Phụ đề</Form.Label>
                  </Col>
                  <Col md={9}>
                    <Form.Control onChange={onChangeSubTitle} required type="text" placeholder="Nhập phụ đề" defaultValue={state.addPopup.subTitle} />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <div></div>
        <Button variant="secondary" className="ms-auto" onClick={handleConfirm}>
          Thêm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(_Popup)